"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiMeasurementApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var CapiMeasurementApi = /** @class */ (function (_super) {
    __extends(CapiMeasurementApi, _super);
    function CapiMeasurementApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new long-lived JSON Web Token to authenticate CAPI requests
     * Create CAPI Auth Token
     */
    CapiMeasurementApi.prototype.createCapiAuthTokenRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling createCapiAuthToken.');
                        }
                        if (requestParameters.capiConnectionId === null || requestParameters.capiConnectionId === undefined) {
                            throw new runtime.RequiredError('capiConnectionId', 'Required parameter requestParameters.capiConnectionId was null or undefined when calling createCapiAuthToken.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi/{capi_connection_id}/tokens".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("capi_connection_id", "}"), encodeURIComponent(String(requestParameters.capiConnectionId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiCreateAuthTokenResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new long-lived JSON Web Token to authenticate CAPI requests
     * Create CAPI Auth Token
     */
    CapiMeasurementApi.prototype.createCapiAuthToken = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCapiAuthTokenRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a CAPI integration in a business
     * Create CAPI Integration
     */
    CapiMeasurementApi.prototype.createCapiIntegrationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling createCapiIntegration.');
                        }
                        if (requestParameters.createCapiIntegrationRequest === null || requestParameters.createCapiIntegrationRequest === undefined) {
                            throw new runtime.RequiredError('createCapiIntegrationRequest', 'Required parameter requestParameters.createCapiIntegrationRequest was null or undefined when calling createCapiIntegration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateCapiIntegrationRequestToJSON)(requestParameters.createCapiIntegrationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiIntegrationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a CAPI integration in a business
     * Create CAPI Integration
     */
    CapiMeasurementApi.prototype.createCapiIntegration = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCapiIntegrationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Soft delete the authentication token
     * Delete CAPI Auth Token
     */
    CapiMeasurementApi.prototype.deleteCapiAuthTokenRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling deleteCapiAuthToken.');
                        }
                        if (requestParameters.capiConnectionId === null || requestParameters.capiConnectionId === undefined) {
                            throw new runtime.RequiredError('capiConnectionId', 'Required parameter requestParameters.capiConnectionId was null or undefined when calling deleteCapiAuthToken.');
                        }
                        if (requestParameters.capiAuthTokenId === null || requestParameters.capiAuthTokenId === undefined) {
                            throw new runtime.RequiredError('capiAuthTokenId', 'Required parameter requestParameters.capiAuthTokenId was null or undefined when calling deleteCapiAuthToken.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi/{capi_connection_id}/tokens/{capi_auth_token_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("capi_connection_id", "}"), encodeURIComponent(String(requestParameters.capiConnectionId))).replace("{".concat("capi_auth_token_id", "}"), encodeURIComponent(String(requestParameters.capiAuthTokenId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Soft delete the authentication token
     * Delete CAPI Auth Token
     */
    CapiMeasurementApi.prototype.deleteCapiAuthToken = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCapiAuthTokenRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all active authentication token(s)
     * Get CAPI Auth Token(s)
     */
    CapiMeasurementApi.prototype.getCapiAuthTokensRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getCapiAuthTokens.');
                        }
                        if (requestParameters.capiConnectionId === null || requestParameters.capiConnectionId === undefined) {
                            throw new runtime.RequiredError('capiConnectionId', 'Required parameter requestParameters.capiConnectionId was null or undefined when calling getCapiAuthTokens.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi/{capi_connection_id}/tokens".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("capi_connection_id", "}"), encodeURIComponent(String(requestParameters.capiConnectionId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiGetAuthTokenResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets all active authentication token(s)
     * Get CAPI Auth Token(s)
     */
    CapiMeasurementApi.prototype.getCapiAuthTokens = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCapiAuthTokensRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a CAPI Integration by ID
     * Get CAPI Integration
     */
    CapiMeasurementApi.prototype.getCapiIntegrationByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getCapiIntegrationById.');
                        }
                        if (requestParameters.capiConnectionId === null || requestParameters.capiConnectionId === undefined) {
                            throw new runtime.RequiredError('capiConnectionId', 'Required parameter requestParameters.capiConnectionId was null or undefined when calling getCapiIntegrationById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi/{capi_connection_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("capi_connection_id", "}"), encodeURIComponent(String(requestParameters.capiConnectionId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiIntegrationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a CAPI Integration by ID
     * Get CAPI Integration
     */
    CapiMeasurementApi.prototype.getCapiIntegrationById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCapiIntegrationByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all CAPI integrations for a business
     * Get CAPI Integrations for Business
     */
    CapiMeasurementApi.prototype.getCapiIntegrationsByBusinessIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getCapiIntegrationsByBusinessId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiIntegrationsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all CAPI integrations for a business
     * Get CAPI Integrations for Business
     */
    CapiMeasurementApi.prototype.getCapiIntegrationsByBusinessId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCapiIntegrationsByBusinessIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update CAPI Integration
     * Update CAPI Integration
     */
    CapiMeasurementApi.prototype.updateCapiIntegrationByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updateCapiIntegrationById.');
                        }
                        if (requestParameters.capiConnectionId === null || requestParameters.capiConnectionId === undefined) {
                            throw new runtime.RequiredError('capiConnectionId', 'Required parameter requestParameters.capiConnectionId was null or undefined when calling updateCapiIntegrationById.');
                        }
                        if (requestParameters.updateCapiIntegrationRequest === null || requestParameters.updateCapiIntegrationRequest === undefined) {
                            throw new runtime.RequiredError('updateCapiIntegrationRequest', 'Required parameter requestParameters.updateCapiIntegrationRequest was null or undefined when calling updateCapiIntegrationById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/capi/{capi_connection_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("capi_connection_id", "}"), encodeURIComponent(String(requestParameters.capiConnectionId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateCapiIntegrationRequestToJSON)(requestParameters.updateCapiIntegrationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CapiIntegrationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update CAPI Integration
     * Update CAPI Integration
     */
    CapiMeasurementApi.prototype.updateCapiIntegrationById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCapiIntegrationByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CapiMeasurementApi;
}(runtime.BaseAPI));
exports.CapiMeasurementApi = CapiMeasurementApi;
